import { BinaryTreeNodeUser } from "functions/src/Users/UsersInterfaces";

//export const  = "";
//Actions
export const initializeTree = "initializeTree";
export const doGetUserTree = "doGetUserTree";
export const doGetUserTreeBatch = "doGetUserTreeBatch";
export const setRootUsername = "setRootUsername";
export const searchUser = "searchUser";
export const refreshTree = "refreshTree";

//Mutations
export const INIT = "INIT";
export const ADD_NODES_TO_USER = "ADD_NODES_TO_USER";
export const CHANGE_ROOT_USERNAME = "CHANGE_ROOT_USERNAME";
export const CLEAR_STATE = "CLEAR_STATE";
export const MARK_NODES_PENDING_UPDATE = "MARK_NODES_PENDING_UPDATE";
export const CLEAR_PENDING_FLAG = "CLEAR_PENDING_FLAG";

export interface UserNetworkState {
  //binaryTree: BinaryTreeNodeUser | null;
  rootNodeUsername: string;
  binaryTreeMap: Map<string, BinaryTreeNodeUser>;
  binaryTreeNodes: Array<BinaryTreeNodeUser>;
  pendingUpdateNodes: Set<string>;
}
export interface GetUserTreeRequest {
  username: string;
  levels: number | undefined;
}

export interface GetUserTreeBatchRequest {
  usernames: string[];
  levels: number | undefined;
}
